<template>
	<div id="layout-simple">
		<slot />
	</div>
</template>
